import {z} from 'zod'
import i18n from '@/translations/i18n'

// Company Info Schema - used for both data model and form validation
export const CompanyInfo = z.object({
    id: z.string().optional(),
    name: z.string().min(1, {message: i18n.t('errors:required')}),
    taxId: z.string().min(1, {message: i18n.t('errors:required')}),
    fiscalCode: z.string().min(1, {message: i18n.t('errors:required')}),
    // Legal address
    legalAddress: z.string().min(1, {message: i18n.t('errors:required')}),
    legalCity: z.string().min(1, {message: i18n.t('errors:required')}),
    legalProvince: z.string().min(1, {message: i18n.t('errors:required')}),
    legalZip: z.string().min(1, {message: i18n.t('errors:required')}),
    // Operational address
    hasDifferentOperationalAddress: z.boolean().default(false),
    operationalAddress: z.string().optional(),
    operationalCity: z.string().optional(),
    operationalProvince: z.string().optional(),
    operationalZip: z.string().optional(),
    // Contact
    phone: z.string().min(1, {message: i18n.t('errors:required')}),
    email: z
        .string()
        .email({message: i18n.t('errors:email_error')})
        .min(1, {message: i18n.t('errors:required')}),
    pec: z
        .string()
        .email({message: i18n.t('errors:email_error')})
        .min(1, {message: i18n.t('errors:required')}),
    // Structure info
    structureType: z.string().min(1, {message: i18n.t('errors:required')}),
    regimeType: z.string().min(1, {message: i18n.t('errors:required')}),
    modalityType: z.string().min(1, {message: i18n.t('errors:required')}),
    nisCode: z.string().min(1, {message: i18n.t('errors:required')}),
    aslReference: z.string().min(1, {message: i18n.t('errors:required')}),
    // Bank info
    bankName: z.string().optional(),
    bankBranch: z.string().optional(),
    iban: z.string().min(1, {message: i18n.t('errors:required')}),
    bic: z.string().min(1, {message: i18n.t('errors:required')})
})
export type CompanyInfo = z.infer<typeof CompanyInfo>

// Use the same schema for form validation
export const CompanyInfoFormValidationSchema = CompanyInfo.omit({id: true})
export type CompanyInfoFormValidationSchema = z.infer<typeof CompanyInfoFormValidationSchema>
